
import { useSelector } from "react-redux"
import styled from "styled-components"
import { setSelectUserData } from "../../features/user/userSlice"
import { showNestedModal } from "../../features/modal/modalSlice"
import { useDispatch } from "react-redux"
import avatar from "../../images/img/avatar.jpg"
import getPastDateAndTime from "../../helper/date/getPastDateAndTime"
import { useState } from "react"
import InputFilterDate from "../shared/input/locationView/InputFilterDate"
import { getDriversInBranchArea, updateFilterDuration, updateFilterDurationType } from "../../features/branchUserLocations/branchUserLocationsSlice"

const Container = styled.div`
    position: absolute;
    top: 0;
    right: 0;
    width: 380px;
    height: 100vh;
    max-height: 100vh;
    overflow-x: hidden;
    overflow-y: auto;
    background-color: ${({theme}) => theme.mainBgColor};

    .top-container{
        padding: 10px 15px;
        width: 100%;
        font-size: var(--font-size-sm);
        font-weight: var(--font-weight-lg);
        color: ${({theme}) => theme.mainTextColor};
        border-bottom: 1px solid ${({theme}) => theme.mainBorderColor};

        display: flex;
        flex-direction: column;
        gap: 15px;

        h4{
            font-size: var(--font-size-sm);
            font-weight: var(--font-weight-lg);
            margin-top: 10px;

        }

        .desc-text{
            font-size: 13px;
            font-weight: var(--font-weight-lg);
        }
        
    }

    .branch-list{
        display: flex;
        flex-direction: column;
        width: 100%;
        cursor: pointer;
        margin-top: 20px;

        .branch-item{
            display: flex;
            flex-direction: column;
            align-items: flex-start;
            padding: 10px 15px;
            /* border-bottom: 2px solid ${({theme}) => theme.mainBorderColor}; */

            .branch-item-name{
                font-size: 14px;
                font-weight: 700;
                border-bottom: 2px solid var(--color-main);
                padding-bottom: 3px;
                width: 100%;

            }

            .user-list{
                display: flex;
                flex-direction: column;
                width: 100%;
                cursor: pointer;

                .no-member{
                    font-size: 15px;
                    font-weight: 500;
                    width: 100%;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    padding: 20px 0;
                    min-height: 100px;

                }

                .user-item{
                    width: 100%;
                    display: flex;
                    align-items: flex-start;
                    padding: 7px 0;

                    .left-side {
                        padding: 10px;

                        img{
                        width: 50px;
                        height: 50px;
                        border-radius: 50%;
                        object-fit: cover;
                        border: 2px solid var(--color-main);
                        }

                    }

                    .right-side {
                        display: flex;
                        flex-direction: column;
                        gap: 5px;
                        width: 270px;
                        padding: 5px;

                        .username {
                        font-size: 12px;
                        font-weight: var(--font-weight-lg);
                        }

                        .phone-number {
                        font-size: 12px;
                        font-weight: var(--font-weight-lg);
                        }

                        .last-time{
                        font-size: 12px;
                        font-weight: var(--font-weight-lg);

                        }

                        .bottom-container{
                            width: 100%;
                            display: flex;
                            align-items: center;
                            justify-content: space-between;
                            gap: 20px;

                            .version{
                                font-size: 12px;
                                font-weight: var(--font-weight-lg);

                            }

                            .button{
                                text-decoration: underline;
                                color: var(--color-main);
                                font-size: 12px;
                                font-weight: var(--font-weight-lg);
                            }
                        }

                    }
                }
                

            }
        }
    }
`


const UserList = () => {

        const {
        branchList,
        filterDurationType,
        filterDurationHour,
        filterDurationDay,
        constantFilterDurationDay,
        constantFilterDurationHour,
    } = useSelector(state => state.branchUserLocations)

    const [typingTimeout, setTypingTimeout] = useState(null);

    const dispatch = useDispatch()

        const handleChange = (e) => {
            if(e?.target?.value?.length < 10){
                dispatch(updateFilterDuration({type: filterDurationType, data: e.target.value.replace(/[^0-9]/g, '')}))
                handleReq(e.target.value.replace(/[^0-9]/g, ''))
            }
        };
        
        const handleReq = (value) => {
            
            // Eğer daha önce bir timeout ayarlanmışsa iptal et
            if (typingTimeout) {
                clearTimeout(typingTimeout);
                }
            // Yeni bir timeout ayarla
            const timeout = setTimeout(() => {
                if(filterDurationType === 1 && parseInt(value) > 0){
                    dispatch(getDriversInBranchArea({
                        duration: parseInt(value)
                    }))
                }
                else if (filterDurationType === 2 && parseInt(value) > 0){
                    dispatch(getDriversInBranchArea({
                        duration: parseInt(value) * 24
                    }))
                }
            }, 1000); // 1 saniye (1000 ms)

            setTypingTimeout(timeout);
        }

  return (
    <Container>
        <div className="top-container">
            <h4>Konum Son Güncelleme</h4>
            <InputFilterDate inputWidth={"100%"} data={filterDurationType === 1 ?  filterDurationHour : filterDurationDay} setData={(e) => handleChange(e)} labelText="Konum Son Güncelleme" name={"dateFilterUserLocs"} dateFilterType={filterDurationType} setDateFilterType={(data) => dispatch(updateFilterDurationType(data))}/>
            <p className="desc-text">{`Son ${filterDurationType === 1 ?  constantFilterDurationHour : constantFilterDurationDay} ${filterDurationType === 1 ? "Saat" : "Gün"} içerisinde konumu güncellenmiş sürücüler listelenmektedir.`}</p>
            <p className="desc-text">! Üye konum tarihlerinde en eski tarih 1 Nisan 2024 tarihidir.</p>
        </div>
        <div className="branch-list">
            {
                branchList?.map(item => (
                    <div className="branch-item">
                        <h3 className="branch-item-name">{item?.branchName?.name} Şube</h3>
                        <div className="user-list">
                            {
                                item?.users?.$values?.map((userItem) => (
                                    <div className="user-item">
                                    <div className="left-side">
                                        <img
                                            src={
                                                userItem.profilePhoto
                                                ? `${process.env.REACT_APP_API_IMG_URI}${userItem.profilePhoto}`
                                                : avatar
                                            }
                                            alt=""
                                        />
                                    </div>
                                    <div className="right-side">
                                        <div className="username">{userItem?.adSoyadUnvan}</div>
                                        <div className="phone-number">{userItem?.phoneNumber}</div>
                                        <div className="last-time">Son Konum Alma: {getPastDateAndTime(item.konumSonGorulme).formattedDate} {getPastDateAndTime(userItem.konumSonGorulme).formattedTime}</div>
                                        <div className="bottom-container">
                                            <div className="version">Sürüm: {userItem.appVersionNumber || "?"}</div>
                                            <button className="button" onClick={(e) => {e.stopPropagation(); dispatch(showNestedModal("surucuProfil")); dispatch(setSelectUserData(userItem.phoneNumber))}}>Profili Görüntüle</button>
                                        </div>
                                    </div>
                                </div>
                                ))
                            }

                            {
                                item?.users?.$values?.length === 0 && <span className="no-member">Üye Bulunamadı!</span>
                            }
                        </div>
                    </div>
                    // <div className="user-item">
                    //     <div className="left-side">
                    //         <img
                    //             src={
                    //                 item.profilePhoto
                    //                 ? `${process.env.REACT_APP_API_IMG_URI}${item.profilePhoto}`
                    //                 : avatar
                    //             }
                    //             alt=""
                    //         />
                    //     </div>
                    //     <div className="right-side">
                    //         <div className="username">{item?.adSoyadUnvan}</div>
                    //         <div className="phone-number">{item?.phoneNumber}</div>
                    //         <div className="last-time">Son Konum Alma: {getPastDateAndTime(item.konumSonGorulme).formattedDate} {getPastDateAndTime(item.konumSonGorulme).formattedTime}</div>
                    //         <div className="bottom-container">
                    //             <div className="version">Sürüm: {item.appVersionNumber}</div>
                    //             <button className="button" onClick={(e) => {e.stopPropagation(); dispatch(showNestedModal("surucuProfil")); dispatch(setSelectUserData(item.phoneNumber))}}>Profili Görüntüle</button>
                    //         </div>
                    //     </div>
                    // </div>
                ))
            }
        </div>
    </Container>
  )
}

export default UserList